import { Button, Box, Typography } from '@mui/material';
export default function TimeRangeSelector({ timeRange, setTimeRange, options }) {
  const defaultOptions = [
    { label: "15 min", value: 15 * 60 * 1000 },
    { label: "30 min", value: 30 * 60 * 1000 },
    { label: "1h", value: 60 * 60 * 1000 },
    { label: "2h", value: 2 * 60 * 60 * 1000 },
  ];

  const buttons = options || defaultOptions;

  return (
    <div className="time-range-selector">
      {buttons.map(btn => (
        <Button
          key={btn.value}
          className={`time-btn ${timeRange === btn.value ? "active" : ""}`}
          onClick={() => setTimeRange(btn.value)}
        >
          {btn.label}
        </Button>
      ))}
    </div>
  );
}